(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-body"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-copy-link]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            var original = btn.getAttribute('aria-label');
            btn.setAttribute('aria-label', 'Copied!');
            setTimeout(function () { btn.setAttribute('aria-label', original); }, 1500);
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (function () {
    var COOKIE_NAME = 'cs_optin_dismissed';

    function setCookie(name, value, maxAgeSeconds) {
      document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAgeSeconds + '; path=/; SameSite=Lax';
    }
    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : null;
    }

    var overlay = document.getElementById('optin-overlay');
    if (!overlay) return;
    var DELAY_MS = parseInt(overlay.dataset.delayMs, 10) || 20000;
    var SUPPRESS_SECONDS = parseInt(overlay.dataset.suppressSeconds, 10) || 259200;
    var closeBtn = document.getElementById('optin-close');
    var form = document.getElementById('optin-form');
    var formWrap = document.getElementById('optin-form-wrap');
    var success = document.getElementById('optin-success');
    var input = document.getElementById('optin-email');

    function suppress() {
      setCookie(COOKIE_NAME, '1', SUPPRESS_SECONDS);
    }

    /* window.csOverlays (layout/theme.liquid) locks the page scroll, keeps Tab inside the
       popup and gives focus back when it closes. */
    function openModal() {
      overlay.classList.add('active');
      window.csOverlays.lock('popup', overlay);
      try { input.focus({ preventScroll: true }); } catch (e) {}
    }

    function closeModal() {
      overlay.classList.remove('active');
      window.csOverlays.unlock('popup');
      suppress();
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('active') && window.csOverlays.top() === 'popup') closeModal();
    });

    if (form) {
      var optinSubmit = form.querySelector('.optin-submit');
      function showOptinError(msg) {
        var err = formWrap.querySelector('.optin-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'optin-error';
          err.setAttribute('role', 'alert');
          form.after(err);
        }
        err.textContent = msg;
        if (optinSubmit) optinSubmit.disabled = false;
      }
      function clearOptinError() {
        var err = formWrap.querySelector('.optin-error');
        if (err) err.textContent = '';
        input.removeAttribute('aria-invalid');
      }
      input.addEventListener('input', clearOptinError);
      function showOptinSuccess() {
        clearOptinError();
        if (optinSubmit) optinSubmit.disabled = false;
        formWrap.classList.add('hidden');
        success.classList.add('active');
        suppress();
        setTimeout(function () {
          overlay.classList.remove('active');
          window.csOverlays.unlock('popup');
        }, 5000);
      }

      /* The submit is relayed into the hidden Klaviyo embed by assets/klaviyo-relay.js,
         which reports success only once Klaviyo has confirmed the signup. */
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var relay = window.csKlaviyoRelay;
        if (!relay) {
          showOptinError('Sign-up is unavailable right now. Please try again shortly.');
          return;
        }
        var email = (input.value || '').trim();
        if (!relay.isValidEmail(email)) {
          input.setAttribute('aria-invalid', 'true');
          showOptinError(email ? 'Please check your email address and try again.' : 'Please enter your email address.');
          input.focus();
          return;
        }
        clearOptinError();
        if (optinSubmit) optinSubmit.disabled = true;
        relay.submit({
          host: overlay.querySelector('.optin-klaviyo-host'),
          email: email,
          onSuccess: showOptinSuccess,
          onError: showOptinError
        });
      });
    }

    if (getCookie(COOKIE_NAME)) return;

    /* Skip visitors Klaviyo already knows: they subscribed through a Klaviyo form or
       arrived from a Klaviyo email. Klaviyo gives every visitor a __kla_id cookie on
       their first page, so the cookie's presence means nothing; only an identified
       profile carries an exchange id, email or profile id inside it. */
    function klaviyoKnowsVisitor() {
      var raw = getCookie('__kla_id');
      if (!raw) return false;
      try {
        var identity = JSON.parse(atob(raw));
        return ['$exchange_id', '$email', 'email', '$id', '$kid', 'id', '$phone_number', 'phone_number']
          .some(function (key) { return !!identity[key]; });
      } catch (err) {
        return false;
      }
    }
    if (klaviyoKnowsVisitor()) return;

    /* Open only when nothing is in the way. Shopify's cookie banner stacks above this overlay
       and covers most of a phone screen. And opening over the search box, the cart, the menu
       or a field being typed in used to take over the keyboard mid-word. */
    function shopperIsBusy() {
      if (window.csOverlays.stack.length || document.querySelector('.mega-panel.open')) return true;
      var el = document.activeElement;
      return !!el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
    }
    function openWhenUnobstructed() {
      var banner = document.getElementById('shopify-pc__banner');
      if ((banner && banner.getBoundingClientRect().height > 0) || shopperIsBusy()) {
        setTimeout(openWhenUnobstructed, 500);
        return;
      }
      openModal();
    }
    setTimeout(openWhenUnobstructed, DELAY_MS);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var isOpen = item.classList.contains('open');
        item.closest('.faq-category').querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('open');
        });
        if (!isOpen) item.classList.add('open');
      });
    });

    document.querySelectorAll('.faq-sidebar a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        document.querySelectorAll('.faq-sidebar a').forEach(function (l) { l.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function(){
    function init(){
      var wrap = document.querySelector('.footer-newsletter');
      if (!wrap || wrap.dataset.relayInit) return;
      wrap.dataset.relayInit = '1';
      var form = wrap.querySelector('.footer-newsletter-form');
      var input = wrap.querySelector('.footer-newsletter-input');
      if (!form || !input) return;

      var submitBtn = form.querySelector('.footer-newsletter-submit');
      function showError(msg) {
        var err = wrap.querySelector('.footer-newsletter-error');
        if (!err) {
          err = document.createElement('div');
          err.className = 'footer-newsletter-error';
          err.setAttribute('role', 'alert');
          form.after(err);
        }
        err.textContent = msg;
        if (submitBtn) submitBtn.disabled = false;
      }
      function clearError() {
        var err = wrap.querySelector('.footer-newsletter-error');
        if (err) err.textContent = '';
        input.removeAttribute('aria-invalid');
      }
      input.addEventListener('input', clearError);

      function showSuccess() {
        clearError();
        if (submitBtn) submitBtn.disabled = false;
        wrap.classList.add('success');
      }

      /* The submit is relayed into the hidden Klaviyo embed by assets/klaviyo-relay.js,
         which reports success only once Klaviyo has confirmed the signup. */
      form.addEventListener('submit', function(e){
        e.preventDefault();
        clearError();
        var relay = window.csKlaviyoRelay;
        if (!relay) {
          showError('Sign-up is unavailable right now. Please try again shortly.');
          return;
        }
        var email = (input.value || '').trim();
        if (!relay.isValidEmail(email)) {
          input.setAttribute('aria-invalid', 'true');
          showError(email ? 'Please check your email address and try again.' : 'Please enter your email address.');
          input.focus();
          return;
        }
        if (submitBtn) submitBtn.disabled = true;
        relay.submit({
          host: wrap.querySelector('.footer-newsletter-klaviyo-host'),
          email: email,
          onSuccess: showSuccess,
          onError: showError
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('click', function(e){
      var link = e.target.closest('[data-cookie-preferences]');
      if (!link || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
      e.preventDefault();
      window.privacyBanner.showPreferences();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
